import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useDataProvider, useTranslate } from 'ra-core';
import { LoadingIndicator } from 'react-admin';
import { ApiSelectionModalTaC } from './ApiSelectionModalTaC';
import { TruncatedTextField } from '../../ui';
import { useLayer7Notify } from '../../useLayer7Notify';
export function ApiSelectionModal(props) {
    const { api, onConfirm, onCancel, apiPlansEnabled, orgUuid } = props;
    const [apiPlans, setApiPlans] = React.useState([]);
    const [selectedApiPlan, setSelectedApiPlan] = React.useState();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [apiEula, setApiEula] = React.useState();
    const classes = useStyles(props);
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const notify = useLayer7Notify();
    React.useEffect(() => {
        async function fetchApiPlans() {
            const { data } = await dataProvider.getApiPlansByApi('apiPlans', {
                apiId: api.id,
                orgUuid: orgUuid,
            }, {
                onFailure: error => notify(error),
            });
            setApiPlans(data);
            setIsLoaded(true);
        }
        async function fetchApiEula() {
            const { data } = await dataProvider.getOne('apiEulas', {
                id: api.apiEulaUuid,
            }, {
                onFailure: error => notify(error),
            });
            setApiEula(data);
        }
        if (api) {
            if (apiPlansEnabled) {
                fetchApiPlans();
            }
            else {
                setIsLoaded(true);
            }
            fetchApiEula();
        }
    }, [JSON.stringify(api)]); // eslint-disable-line
    const onClose = () => {
        setApiPlans([]);
        setSelectedApiPlan(undefined);
        setApiEula(undefined);
        setIsLoaded(false);
        onCancel();
    };
    const onAPIConfirm = () => {
        api.apiPlan = selectedApiPlan;
        setApiPlans([]);
        setSelectedApiPlan(undefined);
        setApiEula(undefined);
        setIsLoaded(false);
        onConfirm();
    };
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: "md", open: !!api, onClose: onClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
        !isLoaded && !apiEula && React.createElement(LoadingIndicator, null),
        isLoaded && !!api ? (React.createElement(React.Fragment, null,
            React.createElement(DialogTitle, { id: "alert-dialog-title" },
                api.name,
                " v",
                api.version),
            selectedApiPlan && (React.createElement(TableContainer, { className: classes.planSummaryTable },
                React.createElement(Table, { size: "small", stickyHeader: true, "aria-label": "sticky table" },
                    React.createElement(TableBody, null,
                        React.createElement(TableRow, null,
                            React.createElement(StyledTableCell, { component: "th", scope: "row" }, selectedApiPlan.name),
                            React.createElement(StyledTableCell, { align: "left" },
                                React.createElement(TruncatedTextField, { record: selectedApiPlan, source: "description" })),
                            React.createElement(StyledTableCell, { align: "left" }, selectedApiPlan.rateLimit),
                            React.createElement(StyledTableCell, { align: "left" }, selectedApiPlan.quota),
                            React.createElement(StyledTableCell, { align: "left" }, selectedApiPlan.quotaInterval)))))),
            apiPlans.length === 0 || selectedApiPlan ? (React.createElement(DialogContent, null,
                React.createElement(ApiSelectionModalTaC, { content: apiEula === null || apiEula === void 0 ? void 0 : apiEula.Content }))) : null,
            apiPlans && apiPlans.length > 0 && !selectedApiPlan ? (React.createElement(DialogContent, null,
                React.createElement(Typography, { className: classes.heading }, translate('apihub.actions.select_an_api_plan')),
                React.createElement(TableContainer, { className: classes.container },
                    React.createElement(Table, { className: classes.table, size: "small", stickyHeader: true, "aria-label": "sticky table" },
                        React.createElement(TableHead, null,
                            React.createElement(TableRow, null,
                                React.createElement(StyledTableCell, { align: "left" }, translate('resources.apiPlans.fields.name')),
                                React.createElement(StyledTableCell, { align: "left" }, translate('resources.apiPlans.fields.description')),
                                React.createElement(StyledTableCell, { align: "left" }, translate('resources.apiPlans.fields.rate_limit')),
                                React.createElement(StyledTableCell, { align: "left" }, translate('resources.apiPlans.fields.quota')),
                                React.createElement(StyledTableCell, { align: "left" }, translate('resources.apiPlans.fields.quota_interval')))),
                        React.createElement(TableBody, null, apiPlans.map(row => (React.createElement(TableRow, { key: row.uuid, hover: true, onClick: () => setSelectedApiPlan(row) },
                            React.createElement(StyledTableCell, { component: "th", scope: "row" }, row.name),
                            React.createElement(StyledTableCell, { align: "left" },
                                React.createElement(TruncatedTextField, { record: row, source: "description" })),
                            React.createElement(StyledTableCell, { align: "left" }, row.rateLimit),
                            React.createElement(StyledTableCell, { align: "left" }, row.quota),
                            React.createElement(StyledTableCell, { align: "left" }, row.quotaInterval))))))))) : null,
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onClose, color: "primary" }, translate('ra.action.cancel')),
                React.createElement(Button, { onClick: onAPIConfirm, color: "primary", autoFocus: true, disabled: !isLoaded ||
                        (isLoaded &&
                            apiPlans.length > 0 &&
                            !selectedApiPlan) }, translate('resources.applications.actions.accept_terms_and_conditions'))))) : null));
}
const StyledTableCell = withStyles(theme => ({
    head: {
        fontSize: theme.typography.body1,
        fontWeight: '600',
        whiteSpace: 'nowrap',
    },
    body: {
        fontSize: theme.typography.body1,
        fontWeight: '500',
    },
}))(TableCell);
const useStyles = makeStyles(theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.grey[600],
        marginBottom: theme.spacing(3),
    },
    planSummaryTable: {
        marginLeft: theme.spacing(1),
        width: '97%',
    },
    table: {
        minWidth: '100%',
    },
    container: {
        maxHeight: '100%',
    },
}), {
    name: 'Layer7ApplicationApiPlansList',
});
//# sourceMappingURL=ApiSelectionModal.js.map